import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { InteractionStatus } from '@azure/msal-browser';

/**
 * Mock MSAL Broadcast Service
 * Replaces MsalBroadcastService when disableAuth is enabled in environment
 * Provides the same interface as MsalBroadcastService but with mock observables
 */
@Injectable({
  providedIn: 'root'
})
export class MockBroadcastService {

  private msalSubject = new Subject<any>();
  private inProgressSubject = new Subject<InteractionStatus>();

  /**
   * Observable for MSAL events (login, logout, account changes, etc.)
   * In mock mode, this never emits any events
   */
  msalSubject$: Observable<any> = this.msalSubject.asObservable();

  /**
   * Observable for interaction status
   * In mock mode, this always returns InteractionStatus.None
   */
  inProgress$: Observable<InteractionStatus> = this.inProgressSubject.asObservable();

  constructor() {
    console.log('[Mock Broadcast Service] Initialized - No MSAL events will be emitted');

    // Immediately emit InteractionStatus.None to indicate no auth interaction is happening
    setTimeout(() => {
      this.inProgressSubject.next(InteractionStatus.None);
    }, 0);
  }
}
